import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Checkbox, Col, Drawer, Form, Row, Spin } from "antd";
import PropTypes from "prop-types";

import { Modals } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";
import { ObjectNumbersToEnglish } from "scripts/helpers";

const Component = ({ data = {}, onUpdate, options: { roles } }) => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { visible } = state;
	const { firstName, id, lastName } = data;
	const { hash, pathname, search } = useLocation();
	const [form] = Form.useForm();
	const navigate = useNavigate();

	const handleClose = () => {
		navigate(-1);
	};

	const handleSubmit = () => {
		form.validateFields().then((values) => {
			values.roles = values.roles.length ? values.roles : null;

			values = ObjectNumbersToEnglish(values);

			API.user
				.roles(id, values)
				.then(() => {
					onUpdate(null, true);
					handleClose();
				})
				.catch(() => {});
		});
	};

	const componentDidUpdate = () => {
		switch (hash) {
			case `#${Modals.ROLE}`: {
				if (id) {
					setState((prevState) => ({ ...prevState, visible: true }));

					form.setFieldsValue(data);
				} else {
					navigate(`${pathname}${search}`, { replace: true });
				}

				break;
			}
			default: {
				if (visible) form.resetFields();

				setState((prevState) => ({ ...prevState, visible: false }));

				break;
			}
		}
	};

	useEffect(componentDidUpdate, [hash]);

	return (
		<Drawer
			className="sp-form-drawer"
			footer={
				<>
					<Button type="primary" onClick={handleSubmit}>
						{Resources.confirm}
					</Button>
					<Button onClick={() => handleClose()}>{Resources.cancel}</Button>
				</>
			}
			onClose={() => handleClose()}
			title={`${Resources.change} ${Resources.role} "${firstName} ${lastName}"`}
			maskClosable={false}
			open={visible}
			width={414}
		>
			<Form layout="vertical" form={form}>
				<Form.Item name="roles" required>
					<Checkbox.Group>
						<Row gutter={[16, 8]}>
							{roles.map((o) => {
								return (
									<Col xs={24} key={o.value}>
										<Checkbox value={o.value}>{o.label}</Checkbox>
									</Col>
								);
							})}
						</Row>
					</Checkbox.Group>
				</Form.Item>
			</Form>
		</Drawer>
	);
};

Component.propTypes = {
	data: PropTypes.object,
	onUpdate: PropTypes.func.isRequired,
	options: PropTypes.object.isRequired,
};

export default Component;
